import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import { CATALOG_CATALOG_FREE_INDEX_SET_DATA } from 'rebook/apps/catalog/constants';


export function fetchInitialData() {
  return async(dispatch, getState) => {
    const currentState = getState().catalogFreeIndex;
    dispatch(setSeoMeta());
    if (!currentState.niches) {
      await dispatch(fetchNiches());
    }
  };
}

export function fetchNiches() {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const url = '/api/catalog/niches/?free_book_count__gte=1';

    return (
      fetchQuery(url, { apiVersion: 3, headers: ssr.headers })
        .then(({ data }) => {
          dispatch(setData({ niches: data.objects }));
        })
        .catch(({ data, resp, error }) => {
          Raven.captureMessage('failed to load free niche list due to server error', {
            level: 'error',
            extra: {
              status: resp ? resp.status : null,
              response: data,
              error,
            },
          });
          throw new Error('failed to load free niche list due to server error');
        })
    );
  };
}

export function setSeoMeta() {
  return (dispatch, getState) => {
    const { booksPerSubscriptionCounter } = getState();
    const title = `Читать книги онлайн бесплатно в электронной библиотеке MyBook: `+
                  `простая регистрация для доступа к ${booksPerSubscriptionCounter.free} бесплатных книг`;

    const description = `Читайте книги бесплатно в электронной библиотеке MyBook. ` +
                        `Простая регистрация для доступа к более чем `+
                        `${booksPerSubscriptionCounter.free} бесплатных книг онлайн. ` +
                        `Искусство, детективы, любовные романы, детские книги, ` +
                        `психология, фэнтези, фантастика, дом, семья, приключения. Простая регистрация.`;
    const canonicalUrl = `https://${BASE_HOST}/catalog/?s=0`;
    dispatch(SeoActions.setData({
      canonicalUrl,
      title,
      description,
    }));
  };
}

export function setData(payload) {
  return {
    type: CATALOG_CATALOG_FREE_INDEX_SET_DATA,
    payload,
  };
}
